import { c as _c } from "react/compiler-runtime";
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { boxSprinkles } from '@/uiPrimitives/layout/box.css';
import { subgridRows } from '@/uiPrimitives/layout/pageGrid/subgridRows';
import { placement } from '@/uiPrimitives/layout/placement.css';
import { textBlock } from '@/uiPrimitives/typography/text';
import { ReactNode } from 'react';

/**
 * This component uses a subgrid that needs to be defined as a parent
 * @example
 * <div className={classes(cardGrid({
 *		size: 'thirdOf12',
 *		subgridRows: 'auto 1fr', // The subject-line + number of children-nodes
 *		rowGap: '3 | h1',
 *	}))}>
 * 		<Card ... ><SomeChildNode /></Card>
 * 		<Card ... ><SomeChildNode /></Card>
 * </ul>
 */
const CardItem = t0 => {
  const $ = _c(5);
  const {
    borderColor: t1,
    children
  } = t0;
  const borderColor = t1 === undefined ? "positiveMuted" : t1;
  let t2;
  if ($[0] !== borderColor) {
    t2 = classes(box({
      paddingBlockStart: "1 | h3",
      borderBlockStartStyle: "solid",
      borderColor,
      borderWidth: "2px"
    }), subgridRows({
      rowGap: "3 | h1",
      alignItems: "start"
    }));
    $[0] = borderColor;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};

/**
 * Use inside card to add a subject
 * It can be placed after the card content to make it belong to the heading of the card
 */
const CardSubject = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(placement({
      order: "-1"
    }), textBlock({
      color: "positiveMuted"
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <p className={t1}>{children}</p>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const Card = {
  Item: CardItem,
  Subject: CardSubject
};